const demoUrls={
    fetchResources: {
        url: '/demo/resource'
    },
    fetchResource: {
        url: '/demo/resource/:id'
    },
};

export default demoUrls;
